import React from "react"
import { ErrorBanner } from "./MessageBanner"

interface LoadingErrorStateProps {
  isLoading: boolean
  loadingMessage?: string
  isError: boolean
  errorMessage?: string
}

const LoadingErrorState: React.FC<LoadingErrorStateProps> = ({
  isLoading,
  loadingMessage,
  isError,
  errorMessage,
}) => {
  if (isLoading) {
    return <div className="my-4">{loadingMessage}</div>
  }

  if (isError) {
    return (
      <ErrorBanner
        error={errorMessage || "Something went wrong, please try again."}
      />
    )
  }

  return null
}

export { LoadingErrorState }
